
import { defineComponent } from "vue";

export default defineComponent({
  name: "EquipmentSummaryItem",
  props: {
    label: String,
  },
});
